function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import CheckmarkIcon from "@digital-hig/icon/lib/esm/ui-controls/checkmark";
import IndeterminateIcon from "@digital-hig/icon/lib/esm/ui-controls/indeterminate";
export var makeCheckboxStyles = function makeCheckboxStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiCheckbox: {
      defaultProps: {
        checkedIcon: /*#__PURE__*/React.createElement(SvgIcon, null, /*#__PURE__*/React.createElement(CheckmarkIcon, null)),
        icon: /*#__PURE__*/React.createElement(SvgIcon, null),
        indeterminateIcon: /*#__PURE__*/React.createElement(SvgIcon, null, /*#__PURE__*/React.createElement(IndeterminateIcon, null))
      },
      styleOverrides: {
        root: _defineProperty({
          padding: "".concat(primitives.spacings["0"], "px"),
          margin: "".concat(primitives.spacings["2"], " 0"),
          outlineOffset: 0,
          '& [class*="MuiSvgIcon-fontSizeSmall"]': {
            height: primitives.spacings["4"],
            width: primitives.spacings["4"]
          },
          "&.Mui-disabled": {
            opacity: tokens.opacities.disabled,
            color: tokens.colors["ink-on-background"]
          },
          "&:hover": {
            backgroundColor: "inherit"
          },
          "&:hover > svg": _objectSpread({
            outline: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-hover"])
          }, tokens.transitions["state-activate"]),
          "&:focus, &.Mui-focusVisible, &:focus-visible > svg": {
            outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["ink-focus"]),
            outlineOffset: primitives.borderWidths.medium,
            borderRadius: primitives.borderRadii.small,
            transition: "outline-color ".concat(primitives.transitions.duration["2"], " ").concat(primitives.transitions.easing.energetic)
          },
          "&:active > svg": _objectSpread({
            outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["fill-success"])
          }, tokens.transitions["state-activate"]),
          '&.Mui-checked:not([class*="MuiCheckbox-indeterminate"])': {
            "& > svg": {
              color: tokens.colors["ink-on-fill-primary"],
              background: tokens.colors["fill-primary"]
            },
            "& span": {
              background: tokens.colors["fill-primary"]
            }
          },
          "& > svg": _objectSpread({
            height: primitives.spacings["5"],
            width: primitives.spacings["5"],
            padding: "2px",
            border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-on-background"]),
            borderRadius: primitives.borderRadii.small,
            boxSizing: "border-box"
          }, tokens.transitions["state-blur"])
        }, "& + [class*=\"MuiFormControlLabel-label\"]", {
          color: tokens.colors["ink-on-background"],
          paddingLeft: primitives.spacings["2"],
          fontSize: primitives.fontSizes["3"],
          lineHeight: primitives.lineHeights.compact
        }),
        colorSecondary: {
          color: "".concat(tokens.colors["ink-on-background"])
        }
      }
    }
  };
};